import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import IOwner from 'src/models/IOwner';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import Owner from 'src/models/tract_detail/Owner';

export default class OwnerUtil {
    public static MapOwner(owner: IOwner) {
        if (owner === undefined) {
            return owner;
        }
        switch (owner.ownerType) {
            case 'Individual': {
                const newOwner = new OwnerIndividual(owner as OwnerIndividual);
                return newOwner;
            }

            case 'Trust': {
                const newOwner = new OwnerTrust(owner as OwnerTrust);
                return newOwner;
            }

            case 'Business': {
                const newOwner = new OwnerBusiness(owner as OwnerBusiness);
                return newOwner;
            }

            case 'Gov-RAL': {
                const newOwner = new OwnerRAL(owner as OwnerRAL);
                return newOwner;
            }

            case 'Gov-BLM': {
                const newOwner = new OwnerBOLM(owner as OwnerBOLM);
                return newOwner;
            }

            case 'Gov-STATE': {
                const newOwner = new OwnerStateLand(owner as OwnerStateLand);
                return newOwner;
            }

            case 'JointTenant': {
                const newOwner = new OwnerJointTenant(owner as OwnerJointTenant);
                return newOwner;
            }

            default:
                return owner;
        }
    }

    // tslint:disable: max-line-length
    public static AddressLine(owner: IOwner) {
        if (owner.address) {
            return (
                owner.address?.addressLine1 +
                ', ' +
                owner.address?.city +
                ', ' +
                (owner.address.state?.abbreviation || 'N/A') +
                ', ' +
                owner.address.zipCode
            );
        }
        return 'N/A';
    }

    public static FullOwnershipName(owner: Owner, isCommunityProperty: boolean) {
        return `${!!owner.spouseName && owner.spouseName?.trim().length > 1 ? owner.name + (!isCommunityProperty ? ', a married person' : ' & ' + owner.spouseName) : owner.name} - ${owner.ownerType}`;
    }
}



// WEBPACK FOOTER //
// ./src/util/OwnerUtil.ts